import { render, staticRenderFns } from "./VisitorRegisterPage.vue?vue&type=template&id=554f85f5&scoped=true&"
import script from "./VisitorRegisterPage.vue?vue&type=script&lang=js&"
export * from "./VisitorRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./VisitorRegisterPage.vue?vue&type=style&index=0&id=554f85f5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f85f5",
  null
  
)

export default component.exports